import React from 'react';
// import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: 60,
    height: 60
  },
  name: {
    marginTop: theme.spacing(1)
  }
}));

const Profile = props => {
  const { className, ...rest } = props;
 const username = (localStorage.getItem("name"));
//  const roles = (localStorage.getItem("roles"));
 const initials = username.charAt(0) + username.charAt(1);

  const classes = useStyles();

  // const user = {
  //   // avatar: '/images/avatars/avatar_1.png',
  //   bio: 'Administrator'
  // };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      {/* <Avatar
            alt="Person"
            className={classes.avatar}
            component={RouterLink}
            src={user.avatar}
            to="/settings" /> */}
            <div id='initials'>
            <div id="names">
              {initials}
            </div>
            </div>
            <Typography
              className={classes.name}
              variant="h4"
            >
              {username}
             
            </Typography>
            {/* <Typography variant="body2">{roles}</Typography> */}
    </div> 
  );
};

Profile.propTypes = {
  className: PropTypes.string
};

export default Profile;
